import { EvseConnector } from 'types/generatedSchemaTypes';
import { create } from 'zustand';

type Search = {
  searchTerm: string;
  searchInputActive: boolean;
  selectedConnector: EvseConnector | undefined;
};

type SearchActions = {
  setSearchTerm: (searchTerm: string) => void;
  resetSearch: () => void;
  setSearchInputActive: (active: boolean) => void;
  setSelectedConnector: (connector: EvseConnector | undefined) => void;
};
export const useSearchStore = create<Search & SearchActions>()((set) => ({
  searchTerm: '',
  searchInputActive: false,
  selectedConnector: undefined,
  setSearchTerm: (searchTerm: string) => set({ searchTerm }),
  resetSearch: () =>
    set({
      searchTerm: '',
      searchInputActive: false,
      selectedConnector: undefined,
    }),
  setSearchInputActive: (active: boolean) => set({ searchInputActive: active }),
  setSelectedConnector: (connector: EvseConnector | undefined) =>
    set({ selectedConnector: connector }),
}));
